import { Component, OnInit } from '@angular/core';
import { CommonService } from './services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'nobleui-angular';
  isLoading = false;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.commonService.loading$.subscribe((s) => {
      this.isLoading = s;
    });
  }
}
